<app-spark-header [title]="title" [compact]="!title" [loggedInUsername]="parentAuth.identity.name ?? ''"
  [patients]="patientOptions" [selectedPatientID]="selectedPatientID" [(openMenu)]="openMenu"
  [sendingLogs]="sendingLogs" [signingOut]="signingOut" (sendLogs)="sendLogs()"
  (patientChanged)="changePatient($event)" (offlinePatients)="openOfflinePatients()" (signOut)="signOut()">
  <ng-container header-actions><ng-content select="[header-actions]" /></ng-container>
</app-spark-header>
